import Http from '@/sub-luca-plugin/utils/http';

// 文件上传
export const upload_file = (params: FormData) => Http.post<string>('/base/v1/upload/upload', params, { timeout: 6000000, isForm: true });

/**
 * 穿透接口 获取key
 */
export const get_bot_key = async (params: {
    /**
     * encryptedBotId
     */
    encryptedBotId: string;
}) => Http.post<string>('/gd-bot/web/bot/v1/get-key', params, { withoutToken: true });
